interface AudienceToggleProps {
  active: 'owner' | 'seeker';
  onChange: (audience: 'owner' | 'seeker') => void;
}

export default function AudienceToggle({ active, onChange }: AudienceToggleProps) {
  return (
    <section className="bg-background-100 border-b border-background-200/70">
      <div className="container-page py-4">
        <div className="max-w-md mx-auto">
          <div className="bg-background-50 rounded-full p-1 flex shadow-sm">
            <button
              onClick={() => onChange('owner')}
              className={`flex-1 py-2.5 px-4 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                active === 'owner'
                  ? 'bg-secondary-500 text-paper-50'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              I Own a Warehouse
            </button>
            <button
              onClick={() => onChange('seeker')}
              className={`flex-1 py-2.5 px-4 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                active === 'seeker'
                  ? 'bg-secondary-500 text-paper-50'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              I Need Storage Capacity
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}